<template>
  <v-row align="center" justify="center" class="changePWForm-page mx-2">
    <v-card width="100%" class="text-xs-center elevation-12" max-width="550px">
      <v-row justify="center" class="ma-0">
        <v-col class="py-0 text-left changePWForm-title">
          {{ $t('비밀번호 재설정') }}
        </v-col>
      </v-row>
      <v-row align="center" justify="center" class="ma-0">
        <v-col class="text-center py-0 mb-10" style="padding: 0 75px;">
          <v-form ref="form">
            <div class="overlap-wrap">
              <i-text-field
                ref="email"
                v-model="email"
                :prepend-inner-icon="mdiEmail"
                :error-messages="emailErrors"
                label="이메일을 입력해주세요."
                :rules="[rules.required]"
                required
                @input="$v.email.$touch()"
                @blur="$v.email.$touch()"
                outlined
                dense
              ></i-text-field>
              <i-btn
                small
                color="#465166"
                class="overlap-confirm mb-10"
                @click="emailCheck"
                block
              >
                <template v-if="emailCheckType != 'S'">
                  {{ $t('인증코드발송') }}
                </template>
                <template v-else>{{ $t('인증코드재발송') }}</template>
              </i-btn>
            </div>
            <div class="overlap-wrap">
              <i-text-field
                v-model="emailCode"
                :prepend-inner-icon="mdiCodeArray"
                :rules="[rules.required]"
                label="이메일 인증코드 입력해주세요."
                required
                outlined
                dense
              ></i-text-field>
              <span class="timer overlap-confirm">
                <div id="timer">
                  <span class="time">{{ timerActive ? timerMsg : '' }}</span
                  ><span v-if="timerMsg == 'timeout'" class="over">{{
                    $t('인증시간초과')
                  }}</span>
                </div>
              </span>
            </div>
            <i-text-field
              v-model="password"
              :prepend-inner-icon="mdiKey"
              :append-icon="show1 ? mdiEye : mdiEyeOff"
              :rules="[
                rules.required,
                rules.min,
                rules.char,
                rules.number,
                rules.specialChar,
              ]"
              :type="show1 ? 'text' : 'password'"
              label="비밀번호를 입력해주세요."
              hint="At least 8 characters"
              value="wqfasds"
              class="input-group--focused"
              @click:append="show1 = !show1"
              @input="$v.password.$touch()"
              @blur="$v.password.$touch()"
              outlined
              dense
            ></i-text-field>
            <i-text-field
              v-model="passwordCheck"
              :prepend-inner-icon="mdiKey"
              :append-icon="show2 ? mdiEye : mdiEyeOff"
              :rules="[
                rules.required,
                rules.min,
                rules.char,
                rules.number,
                rules.specialChar,
                rules.passwordMatch,
              ]"
              :type="show2 ? 'text' : 'password'"
              label="비밀번호를 확인해주세요."
              hint="At least 8 characters"
              value="wqfasds"
              class="input-group--focused"
              @click:append="show2 = !show2"
              @input="$v.passwordCheck.$touch()"
              @blur="$v.passwordCheck.$touch()"
              outlined
              dense
            ></i-text-field>
            <v-subheader class="text-left info-msg">{{
              $t(
                '비밀번호는 8~16자의 영문 대소문자, 숫자 및 특수문자를 사용해주시기바랍니다.',
              )
            }}</v-subheader>
          </v-form>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-row justify="space-between" class="ma-0 px-6 py-4">
        <i-btn color="#777e87" text class="" @click="goLoginPage">로그인</i-btn>
        <i-btn depressed color="primary" class="" @click="goChangePW"
          >비밀번호재설정</i-btn
        >
      </v-row>
    </v-card>
  </v-row>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required, email } from 'vuelidate/lib/validators';

import { getEncryption, postJson } from '@/api/network';
import { getJson } from '@/api/network';
import { DialogMixin } from '@/mixin/dialog.js';
import { LoadingMixin } from '@/mixin/loading.js';

import { mdiEmail, mdiCodeArray, mdiKey, mdiEye, mdiEyeOff } from '@mdi/js';
import RSAKey from '@/utils/rsa/rsa.js';

export default {
  mixins: [validationMixin, DialogMixin, LoadingMixin],
  validations: {
    email: { required, email },
    password: { required },
    passwordCheck: { required },
  },
  props: {
    routeParam: Object,
  },
  data() {
    return {
      mdiEmail,
      mdiCodeArray,
      mdiKey,
      mdiEye,
      mdiEyeOff,
      timer: '',
      timerActive: false,
      setTime: 180,
      timerMsg: '',
      email: '',
      emailCode: '',
      password: '',
      passwordCheck: '',
      logMessage: '',
      invalid: false,
      show1: false,
      show2: false,
      rules: {
        required: value => !!value || '필수입력 사항입니다.',
        min: v => v.length >= 8 || '최소 8자 이상 입력하셔야합니다.',
        char: v =>
          /(?=.*[a-zA-Z])/.test(v) || '최소 하나의 영문자가 필요합니다.',
        number: v => /(?=.*\d)/.test(v) || '최소 하나의 숫자가 필요합니다.',
        specialChar: v =>
          /([!@#$%])/.test(v) || '최소 하나의 특수문자가 필요합니다. [!@#$%]',
        passwordMatch: value =>
          value === this.password || '비밀번호가 일치하지 않습니다.',
      },

      emailCheckType: 'V', // 'C': 중복확인, 'V': 유효한 이메일, 'D': 이메일 중복, 'S': 이메일 전송
    };
  },

  computed: {
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email && errors.push('이메일 형식에 맞지 않습니다.');
      !this.$v.email.required && errors.push('필수입력 사항입니다.');
      return errors;
    },
  },
  methods: {
    async emailCheck() {
      this.emailCheckType = 'C';
      this.$v.$touch();

      if (this.$refs.email.validate() && this.emailErrors.length == 0) {
        try {
          const rsa = new RSAKey();
          const {
            publicKeyModulus,
            publicKeyExponent,
            sessionKey,
          } = await getEncryption();

          rsa.setPublic(publicKeyModulus, publicKeyExponent);
          const p = {
            email: rsa.encrypt(this.email),
            sessionKey: sessionKey,
          };
          getJson(
            'api/login/' + this.$route.params.tenantKey + '/findpw/email/check',
            p,
          ).then(res => {
            if (res.data && res.data.code) {
              if (res.data.code == 'D') {
                this.sendEmailCode();
              } else if (res.data.code == 'H') {
                this.$showAlert({
                  message:
                    '해당 계정은 휴면계정입니다. 휴면해제 화면으로 이동합니다.',
                  callback: this.goDormantUserClear,
                  param: this.email,
                });
              } else if (res.data.code == 'V') {
                this.$showAlert('입력하신 이메일의 가입정보가 없습니다.');
              } else if (res.data.code == 'R') {
                this.$showAlert('이미 탈퇴한 계정입니다.');
              }
            }
          });
        } catch (error) {
          console.log(error);
        }
      }
    },
    async sendEmailCode() {
      this.showLoading();
      const rsa = new RSAKey();

      const {
        publicKeyModulus,
        publicKeyExponent,
        sessionKey,
      } = await getEncryption();

      rsa.setPublic(publicKeyModulus, publicKeyExponent);
      const p = {
        email: rsa.encrypt(this.email),
        sessionKey: sessionKey,
      };
      postJson(
        'api/login/' +
          this.$route.params.tenantKey +
          '/sendCertificateCodeForChangePw',
        p,
      )
        .then(res => {
          if (res.data != null && res.data.hasOwnProperty('status')) {
            if (res.data.status == 'success') {
              this.timerStart();
            }

            this.$showAlert(res.data.message);
          }

          //이메일 인증코드 전송
          this.emailCheckType = 'S';
          this.hideLoading();
        })
        .catch(error => {
          console.log(error.response);
          this.hideLoading();
        });
    },
    async goChangePW() {
      if (this.emailErrors.length == 0 && this.$refs.form.validate()) {
        const rsa = new RSAKey();
        const {
          publicKeyModulus,
          publicKeyExponent,
          sessionKey,
        } = await getEncryption();
        rsa.setPublic(publicKeyModulus, publicKeyExponent);
        const p = {
          email: rsa.encrypt(this.email),
          otp: rsa.encrypt(this.emailCode),
          password: rsa.encrypt(this.password),
          sessionKey: sessionKey,
        };
        postJson(
          'api/login/' + this.$route.params.tenantKey + '/changePassword',
          p,
        )
          .then(res => {
            const v = {
              message: '',
              title: '',
              callback: '',
            };

            if (
              res.data != null &&
              res.data.hasOwnProperty('status') &&
              res.data.status == 'success'
            ) {
              v.message = res.data.message;
              v.callback = this.callback;
            } else {
              v.message = res.data.message;
            }

            this.$showAlert(v);
          })
          .catch(error => {
            console.log(error.response);
          });
      }
    },
    goLoginPage() {
      this.$router.push('/login/' + this.$route.params.tenantKey);
    },
    goDormantUserClear(email) {
      this.$router.push({
        name: 'dormant',
        params: { tenantKey: this.$route.params.tenantKey, email: email },
      });
    },
    timerStart() {
      if (this.timerActive) this.timerStop();
      this.timer = setInterval(this.timerCount, 1000);
    },
    timerStop() {
      clearInterval(this.timer); // 타이머 해제
      this.timerActive = false;
      this.setTime = 180;
      this.timerMsg = '';
    },
    timerCount() {
      if (!this.timerActive) this.timerActive = true;

      var mm = Math.floor(this.setTime / 60);
      var ss =
        this.setTime % 60 < 10 ? '0' + (this.setTime % 60) : this.setTime % 60;
      var msg = mm + ':' + ss + '';
      this.timerMsg = msg; // div 영역에 보여줌
      this.setTime--; // 1초씩 감소
      if (this.setTime < 0) {
        // 시간종료
        clearInterval(this.timer); // 타이머 해제
        this.timerActive = false;
        this.setTime = 180;
        this.timerMsg = 'timeout';
      }
    },
    callback() {
      this.goLoginPage();
    },
  },
};
</script>

<style>
/* .v-card {
  opacity: 0.8;
} */
.v-subheader.info-msg {
  align-items: baseline;
}
.overlap-wrap {
  position: relative;
}
.overlap-wrap .v-text-field input {
  width: 70%;
  max-width: 70%;
}
.overlap-confirm {
  position: absolute;
  right: 10px;
  top: 10px;
}
.timer {
  top: 18px;
  font-size: 14px;
  color: #1976d2;
}
.timer .over {
  color: red;
}
.info-msg::before {
  content: '※';
}
.v-input--selection-controls:first-child {
  margin-top: 0px;
}
/* tablet */
@media all and (max-width: 767px) {
  .v-sheet {
    box-shadow: none !important;
  }
}

/* 김대식 css 작업구간 */

.changePWForm-page .changePWForm-title {
  padding: 80px 75px 32px 75px !important;
  font-size: 30px;
  font-weight: 700;
  color: #363c43;
}

.changePWForm-page .v-card {
  border-radius: 20px !important;
}
.changePWForm-page .v-input__slot {
  min-height: 38px !important;
}
.changePWForm-page .v-icon {
  font-size: 18px !important;
}
.changePWForm-page .v-label {
  font-size: 14px;
}

.changePWForm-page .overlap-confirm {
  height: 38px !important;
  position: static !important;
  color: #fff;
  /* top: 5px !important; */
}

.changePWForm-page .info-msg {
  word-break: keep-all;
}

/* 김대식 css 작업구간 */
</style>
